import React, { useEffect, useRef } from "react";
import { Stepper, Step, StepLabel, StepContent, Typography, Box, CircularProgress, Stack } from "@mui/material";
import axios from "axios";
import moment from "moment";

const defaultLabels = {
	CREATED: "Created",
	GATHERING_DATA: "Gathering Data",
	PREPARING_DATA: "Preparing Data",
	RUNNING_ALLOCATION: "Running Allocation",
	COMPLETED: "Completed",
};

const VerticalProcessStepper = ({
	stepsData,
	setStepsData,
	stepsList = [],
	keyCol = "key",
	labelCol = "name",
	finalStepKeys = ["COMPLETED", "FAILED"],
	getLatestStepsData,
}) => {
	if (typeof getLatestStepsData !== "function")
		getLatestStepsData = () => {
			return [];
		};
	let stepsListKeyStr, labelMap;
	// stepsData.pop();
	if (stepsList?.length > 0) {
		stepsListKeyStr = stepsList.map((row) => row[keyCol]);
		labelMap = stepsList?.reduce((acc, row) => {
			acc[row?.[keyCol]] = row;
			return acc;
		}, {});
	} else {
		stepsListKeyStr = stepsData.map((row) => row[keyCol]);
		labelMap = stepsData?.reduce((acc, row) => {
			acc[row?.[keyCol]] = row;
			return acc;
		}, {});
	}

	const intervalRef = useRef(null);

	const lastProcess = stepsData.at(-1)?.[keyCol];
	const activeStep = stepsListKeyStr.findIndex((stepKey) => stepKey === lastProcess);
	const isFinalStep = finalStepKeys?.includes(lastProcess);

	const stepperActiveStep = isFinalStep ? stepsListKeyStr.length : activeStep;
	console.log(stepsData, "mndbmsdb", stepsListKeyStr, labelMap);

	// Polling for updated steps
	useEffect(() => {
		const fetchSteps = async () => {
			const res = await getLatestStepsData(false);

			const lastStep = res?.[res.length - 1]?.[keyCol];
			const isFinal = finalStepKeys?.includes(lastStep);
			console.log("nvfrhgsdjfjs", lastStep, isFinal, res);
			setStepsData((prev) => (res?.length ? res : prev));

			// Only start polling if not at final step
			if (!isFinal && !intervalRef.current) {
				intervalRef.current = setInterval(fetchSteps, 15000);
			} else if (isFinal && intervalRef.current) clearInterval(intervalRef.current);
		};

		fetchSteps(); // First fetch,

		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
			}
		};
	}, [setStepsData]);
	// Determine which step is currently active

	return (
		<Stepper activeStep={stepperActiveStep} orientation="vertical">
			{stepsListKeyStr.map((stepKey, i) => {
				const stepData = stepsData.find((step) => step.process === stepKey);
				const isStepCompleted = !!stepData;

				return (
					<Step key={stepKey} expanded>
						<StepLabel error={stepKey === "FAILED" && isStepCompleted}>
							{labelMap[stepKey]?.[labelCol] || stepKey}
						</StepLabel>

						<StepContent>
							{stepperActiveStep === i ? (
								<Box sx={{ display: "flex", alignItems: "center" }}>
									<CircularProgress size={12} thickness={5} sx={{ mr: 1 }} />
									<Typography variant="caption" color="textDisabled">
										Running...
									</Typography>
								</Box>
							) : (
								<Stack>
									<Typography variant="caption" color="textSecondary" sx={{ mt: 0.5, ml: 2 }}>
										{moment(labelMap[stepKey]?.created_at).format("DD/MM/YYYY") + " "}
										<Box component="span" fontWeight="bold">
											{moment(labelMap[stepKey]?.created_at).format("hh:mm")}
										</Box>
									</Typography>
									<Typography variant="body2" color="error" sx={{ mt: 0.5, ml: 2 }}>
										{stepKey === "FAILED" && isStepCompleted ? `Error : ${labelMap[stepKey]?.message}` : ""}
									</Typography>
								</Stack>
							)}
						</StepContent>
					</Step>
				);
			})}
		</Stepper>
	);
};

export default VerticalProcessStepper;
